import { Buffer } from 'buffer';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import _ from 'lodash';
// @ts-ignore Fix
window.Buffer = window.Buffer || Buffer;
window.moment = moment;
window._ = _;
